var exports = {
  "h": "middlePaneWrapper__K-Ik1C",
  "_": "milestonePageDescription__sVaM_J",
};

module.exports = exports;
